import { FC } from 'react';
import FormGroup from 'components/ui/FormGroup/FormGroup';
import { useTranslation } from 'react-i18next';
import { OwenerTransferModel } from 'ts/transfer/classes/OwenerTransferModel';
import { ownerValidation } from 'constants/transfer';
import PhoneInput from 'components/shared/ui/PhoneInput';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface PassengerFormProps {
  model: OwenerTransferModel;
  onChangeModel: (model: OwenerTransferModel) => void;
  isSubmitted: boolean;
}

const PassengerForm: FC<PassengerFormProps> = ({ model, onChangeModel, isSubmitted }) => {
  const [t] = useTranslation();
  return (
    <div className="form-wrapper row">
      <FormGroup
        name="firstName"
        value={model.firstName}
        onChange={(firstName) => onChangeModel({ ...model, firstName })}
        label={t('passenger.fn')}
        className="col-12 col-md-6"
        validation={ownerValidation.firstName}
        isSubmitted={isSubmitted}
      />
      <FormGroup
        name="lastName"
        value={model.lastName}
        onChange={(lastName) => onChangeModel({ ...model, lastName })}
        label={t('passenger.ln')}
        className="col-12 col-md-6"
        validation={ownerValidation.lastName}
        isSubmitted={isSubmitted}
      />
      <FormGroup
        name="email"
        type="email"
        value={model.email}
        onChange={(email) => onChangeModel({ ...model, email })}
        label={t('passenger.email')}
        className="col-12 col-md-6"
        validation={ownerValidation.email}
        isSubmitted={isSubmitted}
      />
      <PhoneInput
        value={model.phone}
        onChange={(phone) => onChangeModel({ ...model, phone })}
        className="col-12 col-md-6"
        validation={ownerValidation.phone}
        isSubmitted={isSubmitted}
      />
      <FormGroup
        name="message"
        value={model.message}
        onChange={(message) => onChangeModel({ ...model, message })}
        label={t('passenger.message')}
        className="col-12"
        validation={ownerValidation.message}
        isSubmitted={isSubmitted}
      />
    </div>
  );
};

export default withErrorBoundary(PassengerForm, 'PassengerForm');
